module.exports = __webpack_public_path__ + "static/media/empty-state-graphic.00ee28e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty-state-graphic.png
// module id = 2553
// module chunks = 17